import React from 'react';
import './ResetPasswordPopup.css';
import { Navbar, Page, Popup, Link, View } from 'framework7-react';
import Input from '../../input/Input';
import FormTemplate from '../../templates/formTemplates/FormTemplate';
import Button from '../../button/Button';
import mainAPI from '../../../api/MainAPI';
import Content from '../../helpers/content/Content';
import utils from '../../../utils/utils';
import toasts from '../../../utils/toasts';
import models from '../../../model/models';
import loginController from '../../../controllers/loginController';
import DownloadAppPopup from "../downloadAppPopup/DownloadAppPopup";
import PostResetOptionsPopup from "../postResetOptionsPopup/PostResetOptionsPopup";

export default class ResetPasswordPopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.state = {
			opened: false,
			mode: 'Reset'
		};
	}

	componentDidMount = () => {
		this._checkResetUrl();
		this.blurFocusedInputs();
	};

	// Method to blur any focused inputs
	blurFocusedInputs = () => {
		const focusedElement = document.activeElement;
		if (focusedElement && (focusedElement.tagName === 'INPUT' || focusedElement.tagName === 'TEXTAREA')) {
			focusedElement.blur();
		}
	};

	_checkResetUrl = async () => {
		const queryString = utils.query_string();
		let hash = (window.location.hash || queryString.hash || '').replace('#', '');
		if (hash === 'reset-password') {
			if (queryString.password_reset_guid) {
				setResetGuid(queryString.password_reset_guid, queryString.country || queryString.region);
				window.location = '/#reset-password';
			} else {
				this.setState({ opened: true, mode: 'Reset' });
			}
			await this.validatePasswordResetGuid();
		} else if (hash === 'user-invite') {
			if (queryString.token || queryString.password_reset_guid) {
				setResetGuid(queryString.password_reset_guid, queryString.country || queryString.region);
				window.location = '/#user-invite';
			} else {
				this.setState({ opened: true, mode: 'Update' });
			}
			await this.validatePasswordResetGuid();
		} else if (hash === 'show-tutorial') {
			window.location.hash = '';
			window.popupController.show(DownloadAppPopup, {});
		} else if (hash === 'request-password-reset') {
			toasts.show('link expired, Enter your email address to get another email with a link that has not expired', 5000)
			this.setState({opened: true, mode: 'Reset'}, () => {
				window.f7.views.reset_password.router.navigate('/forgot/password', {
					props: {
						mode: 'Reset',
						email: queryString.email,
						onComplete: this.onForgotSubmitted,
						noBackLink:true
					}
				});
			});
		}
	};
	validatePasswordResetGuid = async () => {
		const user = await mainAPI.user.getForPasswordReset();

		if (!user || user?.error?.response?.data?.details) {
			toasts.show('link expired, Enter your email address to get another email with a link that has not expired', 5000)
			window.f7.views.reset_password.router.navigate('/forgot/password', {
				props: {
					mode: this.state.mode,
					email: user?.error?.response?.data?.details,
					onComplete: this.onForgotSubmitted
				}
			});
		}
	};

	_validPassword = () => {
		let value = this.getValue();
		if (value.password.length < 8) {
			toasts.error('Passwords must be 8 characters or longer');
			return false;
		}
		if(value.password === value.password.toLowerCase()){
			toasts.error('Passwords must contain 1 uppercase character');
			return false;
		}
		if(value.password === value.password.toUpperCase()){
			toasts.error('Passwords must contain 1 lowercase character');
			return false;
		}
		return true;
	};

	onForgotSubmitted = () => {
		this.setState({opened: false});
	};

	_reset = async () => {
		if (!this._validPassword()) return;
		let value = this.getValue();
		let user = await mainAPI.user.updateReturnError({ password: value.password });
		if(user?.error?.response?.data?.err === 'DUPLICATE'){
			return toasts.error('You cannot use your existing password', 2500)
		}
		if(user?.error?.response?.data?.err === 'ACCOUNT_DISABLED'){
			return toasts.error('Your account is disabled. An admin can enable it', 2500)
		}
		const expiredLink = user?.error?.response?.data?.err === 'PASSWORD_RESET_EXPIRED';
		const generalError = !user || user?.error;
		if (expiredLink || generalError) {
			let message = 'Password reset expired, Enter your email address to get another email with a link that has not expired'
			if(this.state.mode === 'Update'){
				message = 'Invite link expired, Enter your email address to get another email with a link that has not expired'
			}
			toasts.error(message, 5000)
			window.f7.views.reset_password.router.navigate('/forgot/password', {
				props: {
					mode: this.state.mode,
					email: user?.error?.response?.data?.details,
					onComplete: this.onForgotSubmitted
				}
			});
			return;
		}
		delete localStorage.password_reset_guid;
		utils.setToken(user.token, user.region);
		models.user.setCurrent(user);
		this.setState({ opened: false });
		window.popupController.hide(ResetPasswordPopup);
		const queryString = utils.query_string();
		let hash = (window.location.hash || queryString.hash || '').replace('#', '');
		if (hash === 'user-invite') {
			window.popupController.show(DownloadAppPopup, {});
			window.location.hash = '#show-tutorial';
			loginController.hide();
			utils.hardReloadApp()
		} else {
			loginController.hide();
			// Show the new post-reset options popup for regular password reset
			window.popupController.show(PostResetOptionsPopup, {});
		}

	};

	render() {
		return (
			<Popup tabletFullscreen opened={this.state.opened} className="g-reset-password-popup">
				<View name={'reset_password'} stackPages>
					<Page className="reset-password-popup-page">
						<Navbar title={this.state.mode + ' Password'}></Navbar>
						<Content>
							<div className="label">Enter your new password</div>
							<Input className="border" value="" type="password" ref={(ref) => (this.myRefs.password = ref)} />
						</Content>
						<Button bg="blue" color="white" center onClick={this._reset}>
							{this.state.mode}
						</Button>
						<Link className="sendAnother" href="/forgot/password">
							Send another reset email
						</Link>
					</Page>
				</View>
			</Popup>
		);
	}
}

const setResetGuid = (guid, region) => {
	localStorage.clear();
	localStorage.password_reset_guid = guid;
	localStorage.region = region;
};
